module.exports = __webpack_public_path__ + "img/CrimsonText-SemiBold.6676e58a.svg";